import type { AppearanceVariant } from '@crowdex/ui/lib/appearance/chrome-theme';
import { useSyncExternalStore } from 'react';
import { type Appearance, DEFAULT_APPEARANCE } from './appearance';

type ActiveAppearance = Readonly<{ appearance: Appearance; variant: AppearanceVariant }>;

let active: ActiveAppearance = { appearance: DEFAULT_APPEARANCE, variant: 'dark' };
const listeners = new Set<() => void>();

/** Called with what `applyAppSettings` applied, so code blocks and terminals follow it. */
export function setActiveAppearance(appearance: Appearance, variant: AppearanceVariant): void {
  if (active.appearance === appearance && active.variant === variant) return;
  active = { appearance, variant };
  for (const listener of listeners) listener();
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/** The appearance in effect and the variant shown. */
export function useActiveAppearance(): ActiveAppearance {
  return useSyncExternalStore(
    subscribe,
    () => active,
    () => active,
  );
}
